import type { SolanaConverter } from '../../type'
import convertUnknownToActions from './unknown'

const convertToActions: SolanaConverter = (args) => {
  // unknown の場合
  const unknownResult = convertUnknownToActions(args)
  if (unknownResult !== undefined) {
    return unknownResult
  }

  return undefined
}

export default convertToActions
